export default (function () {
  return document.compatMode === "BackCompat";
});